export const prettyPrintFacility = (facility?: {
  name?: string | null | undefined;
  streetAddress1?: string | null | undefined;
  customerFacilityId?: string | null | undefined;
}) => {
  if (!facility) {
    return "";
  }
  return `${facility?.name} ${
    facility?.streetAddress1 ? `(${facility?.streetAddress1})` : ""
  } ${facility?.customerFacilityId ? `[${facility?.customerFacilityId}]` : ""}`;
};
